/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'

export default {
  SET_ACTIVE_PROJECT_URL(state, url) {
    state.ActiveProjectInfo['url'] = url
  },
  SET_ACTIVE_PROJECT_TITLE(state, name) {
    state.ActiveProjectInfo['title'] = name
  },
  SET_ACTIVE_PROJECT_ID(state, id) {
    state.ActiveSpaceInfo['id'] = id
  },
  SET_ACTIVE_PROJECT(state, payload) {
    state.ActiveProjectInfo = payload
  },
  SET_PROJECT_LIST(state, payload){
    state.projects = payload
  },
  SET_ACTIVE_USER_LEVEL(state, payload){
    state.ActiveProjectLevel = payload
  },

  SET_WORKSPACE_LIST(state, payload){
    state.workspaceList = payload
  },
  SET_SELECT_WORKSPACE(state, payload){
    state.selectWorkspaceInfo = payload
  },
  SET_SELECT_PROJECT(state, payload){
    state.selectProjectInfo = payload
  },
  SET_WORKSPACE_PROJECT_LIST(state, payload){
    state.workspaceProjects =  payload.sort(function(a,b) {return a.workspace_id > b.workspace_id ? -1 : a.workspace_id > b.workspace_id ? 1 : 0 })
    for(var i = 0; i < state.workspaceProjects.length; i++){
      // Vue.set(state.workspaceProjects[i], 'label', state.workspaceProjects[i].id+'. '+state.workspaceProjects[i].title)
      Vue.set(state.workspaceProjects[i], 'label', state.workspaceProjects[i].title)
    }
  },
  CREATE_PROJECT(state, payload){
    state.projects.unshift(payload)
  },
  UPDATE_PROJECT(state, payload) {
    const projectIndex = state.projects.findIndex((e) => e.id == payload.id)
    state.projects[projectIndex].title = payload.title
  },
  DELETE_PROJECT(state, payload) {
    const projectIndex = state.projects.findIndex((e) => e.id == payload)
    // projects 배열 안에 id == payload 값을 찾겠다.
    // findIndex는 하나씩 꺼내온다.
    state.projects.splice(projectIndex, 1)
  }
}
